






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../../../../domain/document";
import { FixedLoading } from "../../../../../system";
import FixedPhraseTreeSelector from "../../../../../document/fixedPhrase/FixedPhraseTreeSelector.vue";
import { FixedPhraseKinds } from "../../../../../document/fixedPhrase/FixedPhraseKinds";
import { FixedPhraseTreeSelectorMixin } from "../../../../../document/fixedPhrase/mixins";
import { FixedPhraseTreeViewerMixin } from "../mixins";
import { IEditFixedPhrase } from "../../../../../document/fixedPhrase/IEditFixedPhrase";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class ReceptionUserFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
  FixedPhraseTreeViewerMixin,
) implements IEditFixedPhrase {
  @Prop()
  userId: string;

  created(): void {
    this.loadDirectories();
  }

  private loadDirectories(): void {
    this.getFixedPhrase(FixedPhraseKinds.ReceptionUser, this.userId)
    .then(d => this.rootFixedPhrase = d)
    .catch(e => {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "個人定型文取得失敗",
        "個人定型文を読み込めませんでした。",
        e);
    });
  }

  mounted(): void {
    this.selector = this.$refs.selector;
    window.addEventListener("message", this.onWindowNotify, false);
  }

  destroyed(): void {
    window.removeEventListener("message", this.onWindowNotify, false);
  }

  private onWindowNotify(event: any): void {
    try {
      const message = JSON.parse(event.data);
      if (message.key === "userFixedPhraseUpdated") {
        this.loadDirectories();
      }
    } catch {}
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    const latest = await this.getFixedPhrase(FixedPhraseKinds.ReceptionUser, this.userId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.ReceptionUser, this.userId);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.ReceptionUser, result, () => this.notifyMessage("userFixedPhraseUpdated"));
  }
}
